import { Directive } from '@angular/core';

@Directive({
    selector: '[appAllowPermission]',
    standalone: false
})
export class AllowPermissionDirective {

  constructor() { }

}
